import React, {Component} from 'react';
import {connect} from 'react-redux';
import SelectBox from "../../components/selectbox";
import {CurrenciesAction} from "../../actions";
import CheckNumber from "../../lib/checkNumber";
import returnNumber from "../../lib/returnNumber";

class Index extends Component {

    constructor(props) {
        super(props);
        this.state={
            value:props.input.value,
            error:props.meta.error
        }
    }

    componentDidMount() {
        this.props.getCurrencies();
    }

    static getDerivedStateFromProps(props, state) {
        let result = {};
        if (props.input && (props.input.value !== state.value)) {
            result.state = props.input.value;
        }
        if (props.meta && (props.meta.error !== state.error)){
            result.error = props.meta.error;
        }
        return result;
    }

    handleChange(value) {
        this.props.input.onChange(value);
    }
    normalizeValue(value){
        if (value)
            return{...value, key:value.id, value:value.symbol_fa}
        else
            return ""
    }
    render() {
        // const{value, error} = this.state;
        const {input, meta, label} = this.props;
        return (
            <SelectBox
                input={{
                    name: "currency",
                    value: this.normalizeValue(input && input.value),
                    onChange: value => this.handleChange(value)
                }}
                label={label}
                meta={{ error: meta && meta.error }}
                options={this.props.data}
                disable={this.props.loading}
            />

        );
    }
}

const mapStateToProps = store => {
    return {
        loading: store.Currencies.loading,
        error: store.Currencies.error,
        data: store.Currencies.data.map((item) => {
            return{
                ...item,
                key:item.id,
                value: item.symbol_fa
            }
        })
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getCurrencies: () => {
            dispatch(CurrenciesAction.get());
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Index);